import { IStore } from 'src/interfaces/store';
import { StoreExtractor } from './types';

export class StoreIdExtractor implements StoreExtractor<string> {
    extract(store: IStore): string {
        return store._id;
    }

    shouldInclude(store: IStore, makeId?: string): boolean {
        return store.make?._id === makeId;
    }
}
